<div class="admin-custom-scripts-edit-modal">
    <div class="modal-header">
        <div style="float:left">
            <h4 class="modal-title" translate="editScript"></h4>
        </div>
        <div style="float:right">
            <button type="button" class="close" aria-label="Close" (click)="onCancel()">
                <icon class="icon aa-icon-close-icon"></icon>
            </button>
        </div>
    </div>
    <div class="modal-body">
        <div class="row">
            <iframe #legacyFrame class="ifrmContainer" style="border: none;width: 100%;height: 680px" [src]="url | safe" (load)="onFrameLoad()"></iframe>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="onCancel()" translate="close"></button>
    </div>
</div>

<div class="unsaved-changes-backdrop" *ngIf="showUnsavedPrompt">
    <div class="unsaved-changes-modal">
        <div class="unsaved-changes-title" translate="pleaseConfirm"></div>
        <div class="unsaved-changes-message" translate="unsavedChanges"></div>
        <div class="unsaved-changes-actions">
            <button type="button" class="btn btn-secondary" (click)="onUnsavedDiscard()" translate="discard"></button>
            <button type="button" class="btn btn-secondary" (click)="onUnsavedCancel()" translate="cancel"></button>
        </div>
    </div>
</div>
